import React from "react";
import Chart from "react-apexcharts";
import { Box, Typography } from "@mui/material";
import "./Top10Variety.css";

export default function Top10Variety({ data }) {
  if (!data || data.length === 0) {
    return (
      <Box className="top-variety-box">
        <Typography variant="h6" className="top-variety-title">
          Ən Çox Stok Sahib 15 Məhsul
        </Typography>
        <Box className="top-variety-no-data-simple">
          <Typography variant="body1">Məlumat tapılmadı</Typography>
        </Box>
      </Box>
    );
  }

  const sortedData = [...data].sort((a, b) => b.value - a.value);
  const left = [];
  const right = [];
  for (let i = 1; i < sortedData.length; i++) {
    if (i % 2 === 1) left.push(sortedData[i]);
    else right.push(sortedData[i]);
  }
  const newData = [...left.reverse(), sortedData[0], ...right];

  const categories = newData.map(item => item.productName);
  const seriesData = newData.map(item => item.value);

  function generateDistinctColors(count) {
    const colors = [];
    while (colors.length < count) {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }

      const rgb = parseInt(color.slice(1), 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = rgb & 0xff;
      const avg = (r + g + b) / 3;

      if (avg < 50 || avg > 200) continue;

     const isSimilar = colors.some(c => {
        const rc = parseInt(c.slice(1, 3), 16);
        const gc = parseInt(c.slice(3, 5), 16);
        const bc = parseInt(c.slice(5, 7), 16);
        return Math.abs(r - rc) < 40 && Math.abs(g - gc) < 40 && Math.abs(b - bc) < 40;
      });
      if (!isSimilar) colors.push(color);
    }
    return colors;
  }

  const barColors = generateDistinctColors(newData.length);

  const series = [
    {
      name: "Miqdar",
      data: seriesData
    }
  ];

  const options = {
    chart: {
      type: "bar",
      height: 360,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: "55%",
        distributed: true
      }
    },
    colors: barColors,
    dataLabels: {
      enabled: true,
      style: { fontSize: "14px", fontWeight: "700", colors: ["#111"] },
      offsetY: -8,
      formatter: function (value, { seriesIndex, dataPointIndex, w }) {
        const item = newData[dataPointIndex];
        const unit = (item.subcategoryName === "Motor yağı" || item.subcategoryName === "Transmissiya yağı") ? "Litr" : "Ədəd";
        return value + " " + unit;
      }
    },
    xaxis: {
      categories,
      labels: { show: false },
      axisBorder: { show: true, color: "#d1d5db", height: 1 },
      axisTicks: { show: false }
    },
    yaxis: {
      labels: { style: { colors: "#555" } },
      axisBorder: { show: true, color: "#d1d5db" }
    },
    grid: { show: false },
    legend: { show: false },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.3,
        opacityFrom: 0.95,
        opacityTo: 0.85,
        stops: [0, 100]
      }
    }
  };

  return (
    <Box className="top-variety-box">
      <Typography variant="h6" className="top-variety-title">
        Ən Çox Stok Sahib 15 Məhsul
      </Typography>
      <Chart options={options} series={series} type="bar" height={490} />
    </Box>
  );
}
